
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import Planimpfung from '@/types/Planimpfung';
    import { PlanItem } from '@/types/Reiseplan';
    import { DataTableHeaders } from '@/types';
    import {mapGetters, mapState} from 'vuex';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
    })
    export default class PlaeneDetailDatatable extends Vue {
        @Prop() items!: PlanItem<Planimpfung | PatUntersuchung>[];
        @Prop({ default: () => false }) isReadonly!: boolean;

        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<PlanItem<Planimpfung | PatUntersuchung>, 'actions' | 'fw_data'> {
            return [
                { text: 'Datum', value: 'datumGeplant' },
                { text: 'Impfung / Untersuchung', value: 'bezeichnung' },
                { text: 'durchgeführt', value: 'isDisabled' },
                { text: 'Eingetragen am/von', value: 'fw_data' },
                { text: '', value: 'actions', sortable: false, width: this.getWidth },
            ];
        }

        get getWidth() {
            return this.getSystemEinstellung('muw').isEnabled() ? 150 : 100;
        }

        public resetAbgelehnt(item: any) {
            item.asImpfung.abgelehnt = 'n';
        }

        public resetGenehmigt(item: any) {
            item.asImpfung.genehmigt = 'n';
        }

        /*public resetDurchgefuehrt(item:any) {
            if (item.data.impfdatum) {
                item.data.impfdatum = null;
            } else if (item.data.untersuchungsdatum) {
                item.data.untersuchungsdatum = null;
                item.data.abnahmedatum = null;
            }
        }*/
    }
